import 'js/app';

import { triggerJs } from 'js/tools';
import ToolTips from 'js/toolTips';
import validator from 'js/validator';

import Favorite from 'components/favorite/favorite';
import FilterCloud from 'components/filterCloud/filterCloud';
import Pagination from 'components/pagination/pagination';
import ResponsiveImage from 'components/responsiveImage/responsiveImage';

import accordeon from 'components/accordeon/accordeon';
import checkboxGroup from 'components/checkboxGroup/checkboxGroup';
import ctaCall from 'components/ctaCall/ctaCall';
import floatingMenu from 'components/floatingMenu/floatingMenu';
import inputCheckbox from 'components/inputCheckbox/inputCheckbox';
import inputRange from 'components/inputRange/inputRange';
import inputSearch from 'components/inputSearch/inputSearch';
import inputSelect from 'components/inputSelect/inputSelect';
import inputText from 'components/inputText/inputText';
import multiSelect from 'components/multiSelect/multiSelect';
import autocomplete from 'components/autocomplete/autocomplete';

import searchResults from 'pagetypes/searchResults/searchResults';

const componentList = [
    { name: 'favorite', constructor: Favorite },
    { name: 'filter-cloud', constructor: FilterCloud },
    { name: 'pagination', constructor: Pagination },
    { name: 'responsive-image', constructor: ResponsiveImage }
];

window.viabovag.register(componentList);
window.viabovag.scan();

window.viabovag.toolTips = new ToolTips();

const fieldsToValidate = document.querySelectorAll('[data-validation-config]');

fieldsToValidate.forEach(field => validator.initFieldValidation(field));

triggerJs('accordeon', accordeon);
triggerJs('checkbox-group', checkboxGroup);
triggerJs('cta-call', ctaCall);
triggerJs('floating-menu', floatingMenu);
triggerJs('input-checkbox', inputCheckbox);
triggerJs('input-search', inputSearch);
triggerJs('input-select', inputSelect);
triggerJs('input-range', inputRange);
triggerJs('input-text', inputText);
triggerJs('multi-select', multiSelect);
triggerJs('input-autocomplete', autocomplete);

triggerJs('pt-search-results', searchResults);
